export const CLIENTS_LOAD_REQUEST = 'CLIENTS_LOAD_REQUEST';
export const CLIENTS_LOAD_SUCCESS = 'CLIENTS_LOAD_SUCCESS';
export const CLIENTS_LOAD_FAILURE = 'CLIENTS_LOAD_FAILURE';
